export class MessageBook {
  symbol: string;
  type: string;
  buy: Buy[];
  sell: Sell[];
  errorMessage: any;
}

export class Buy {
  Q: any;
  P: any;
  C: any;
  FQ: string;
  QTD: any;
}

export class Sell {
  Q: any;
  P: any;
  C: any;
  FQ: string;
  QTD: any;
}
